/**
 *    __________ ______ Copyright (C) Smart Software Factory SA de CV
 *   / ___/ ___// ____/ All Rights Reserved
 *   \__ \__ \ / /_     Unauthorized copying of this file,
 *  ___/ /__/ / __/     via any medium is strictly prohibited
 * /____/____/_/        Proprietary and confidential
 *
 * Written by David Canul <david@ssf.com.mx>, Jun 2019
 *
 * This component lists all the sales crawled from g4s
 */
import React, { Component } from 'react';
import {
  Row,
  Pagination,
  Col,
  DatePicker,
  Table,
  Spin,
  Select,
  Button,
  Modal,
  Form,
  Card,
  Input,
  Descriptions,
  Popconfirm,
  Tag,
  Tabs,
  Alert,
  Typography,
  Popover,
} from 'antd';
import {
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';
import {
  Sale,
  SaleSelected,
  Invoice,
  Email,
  FiscalPermission,
  Equipment,
  FormaPagoCondicion,
  FiscalData,
  Corte,
  CompanySales,
  SystemConfigInvoice,
  SystemConfig,
  Page,
  InvoiceItem,
  InvoiceItemFilters,
} from 'types/type';
import { connect } from 'react-redux';
import { RootState } from '../../store/configureStore';
import {
  alreadyInvoice,
  changeBillable,
  changePaymentType,
  changeformaPago,
  changeToBill,
  downloadFileByUuidSat,
  invoiceAll,
  invoicingSale,
  page,
  sendAllSalesToInvoice,
  setEndDate,
  setInitDate,
  cleanSales,
  getFormaPago,
  setCortes,
  clearCortes,
  getSaleByIus,
  changeCustomer,
  changeToInternal,
  changeToSale,
  getZipFile,
  createExcelByFilters,
} from './redux/actions';
import {
  addSaleToStagingArea,
  cancelInvoiceByUuidSat,
  InvoiceActionConstructors,
  removeSaleToStagingArea,
  resendInvoce,
  resendInvoice,
  saveInvoce,
} from '../invoices/redux/actions';
import { getFiscalData } from '../homeUser/invoiceUser/redux/actions';
import { canRegisterUser } from '../login/redux/actions';
import moment, { Moment } from 'moment';
import { Permissions as P } from 'commons/permissions';
import { isAllowed, getDecodeToken } from 'security/index';
import { SelectValue } from 'antd/lib/select';
import { isEmpty } from 'lodash';
import {
  getCompanySales,
  getFiscalPermission,
  getEquipmentsNumbers,
} from '../company/redux/actions';
import { InvoiceState } from 'routes/invoices/redux/reducers';
import FiscalDataForm from '../login/FiscalData/fiscalDataForm';
import { InvoiceRules as r } from '../login/FiscalData/rulesFiscalData';
import { FormComponentProps } from 'antd/lib/form';
import { initInvoice } from 'commons/initTypes';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Popups } from 'commons/components/popups/popups';
import { Strings as i8n } from 'commons/strings';
import { Redirect } from 'react-router';
import {
  formatStringDateToDisplay,
  sleep,
  subStringWithEllipsis,
  toTitleCase,
} from 'commons/functions';
import {
  getSystemConfig,
  getSystemConfigInvoice,
} from '../configuration/redux/actions';
import './style.css';
import Text from 'antd/lib/typography/Text';
import PaginatedSelect from 'routes/invoices/components/SelectPaginated';

interface DispatchProps {
  page: (filters: InvoiceItemFilters) => void;
  getSystemConfig: () => void;
  /* saleInfoBilledAndCanceled: (
    initDate: Date,
    endDate: Date,
    distributionCenter: string,
  ) => void; */
  /* getExcel: (
    customer: string,
    initDate: Date,
    endDate: Date,
    orderDate: string,
    filter: string,
    allowBillable: boolean,
    distributionCenter: string,
    requiredInvoice: string,
    serviceNumberId: string,
    equipmentId: Array<string>,
    formaPago: string,
    rfc: string,
    orderRFC: string,
    cutFolio: Array<string>
  ) => void; */
  downloadFileByUuidSat: (id: string, name: string) => void;
  invoicingSale: (
    sale: Sale,
    customer: string,
    initDate: Date,
    endDate: Date,
    filter: string,
    pagePosition: number,
    orderDate: string,
    allowBillable: boolean,
    distributionCenter: string,
    requiredInvoice: string,
    serviceNumberId: string,
    equipmentIds: Array<string>,
    formaPago: string,
    rfc: string,
    orderRFC: string,
    cutFolio: Array<string>,
  ) => void;
  sendAllSalesToInvoice: (
    excludeSaleIds: string[],
    customer: string,
    initDate: Date,
    endDate: Date,
    filter: string,
    pagePosition: number,
    orderDate: string,
    allowBillable: boolean,
    distributionCenter: string,
    requiredInvoice: string,
    serviceNumberId: string,
    equipmentIds: Array<string>,
    formaPago: string,
    rfc: string,
    expectedSales: number,
    singleInvoice: boolean,
    orderRFC: string,
    cutFolio: Array<string>,
    idUser: string,
  ) => void;
  changeBillable: (id: string, billable: boolean) => void;
  changePaymentType: (
    id: string,
    paymentType: string,
    distCenterId: string,
  ) => void;
  changeformaPago: (id: string, formaPago: string) => void;
  changeToBill: (
    id: string,
    toBill: boolean,
    total: number,
    totalVolume: number,
  ) => void;
  resendInvoce: (id: string) => void;
  resendInvoice: (id: string, sendTo: string) => void;
  cancelInvoiceByUuidSat: (uuidSat: string, reason: string) => void;
  getCompanySales: () => void;
  setInitDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  alreadyInvoice: (id: string, callback: () => void) => void;
  invoiceAll: () => void;
  getFiscalPermission: (companyId: string) => void;
  getEquipmentsNumbers: () => void;
  cleanSales: () => void;
  getFormaPago: () => void;
  setCortes: (
    equipmentIds: Array<string> | undefined,
    initDate: Date,
    endDate: Date,
  ) => void;
  clearCortes: () => void;
  getFiscalData: (userId: string, isSales: boolean, distCent: string) => void;
  canRegisterUser: () => void;
  getSaleByIus: (ius: string) => void;
  /* getExcelBilled: (
    initDate: Date,
    endDate: Date,
    distributionCenter: string,
    newExcel: boolean,
  ) => void; */
  changeCustomer: (id: string, customerCode: string) => void;
  changeToInternal: (idCut: string) => void;
  changeToSale: (idCut: string) => void;
  getZipFile: (
    initDate: Date,
    endDate: Date,
    distributionCenter: string,
    email: string,
    customerRfc: string,
  ) => void;
  /* getExcelCancelled: (
    initDate: Date,
    endDate: Date,
    distributionCenter: string,
  ) => void; */
  getSystemConfigInvoice: () => void;
  createExcelByFilters: (
    filters: InvoiceItemFilters,
    emailToSend: string,
  ) => void;
}
interface StateProps {
  multipleInvoicePage: Page<InvoiceItem>;
  isFetching: boolean;
  isFetchingBilled: boolean;
  companySalesList: CompanySales[];
  initialDate: Moment;
  endedDate: Moment;
  multicenter: boolean;
  isEquimentNumber: boolean;
  sumTotalLK: number;
  sumTotalM: number;
  sumTotalLKBillable: number;
  sumTotalMBillable: number;
  sumTotalLKSelected: number;
  sumTotalMSelected: number;
  saleSelectedList: SaleSelected[];
  salesStagingArea: Sale[];
  paymentChange: boolean;
  totalElementsBillable: number;
  totalElementsSelected: number;
  fiscalPermissions: Array<FiscalPermission>;
  equipmentNumbers: Array<Equipment>;
  cortes: Array<Corte>;
  formaPago: Array<FormaPagoCondicion>;
  fiscalDataList: FiscalData[];
  canRegistred: boolean;
  totalSales: string;
  billedSalestotal: string;
  totalVolumeSalesTotal: string;
  totalSalesSize: string;
  totalCancel: string;
  systemConfigInvoice: SystemConfigInvoice;
  counterOnlySales: string;
  systemConfig: SystemConfig;
  permissionNumbersWithoutFolioSerie: Array<string>;
}

type Props = StateProps &
  FormComponentProps &
  InvoiceState &
  DispatchProps &
  InvoiceActionConstructors;

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const defaultEquipmentsIds: Array<string> | any = [];
const defaultCutFolio: Array<string> = [];

class MultipleInvoicesListComponent extends Component<Props> {
  public state = {
    pagePosition: 0,
    type: 'ALL',
    unitType: 'L',
    endOpen: false,
    orderDate: 'NONE',
    dc: '',
    invoiceRequired: 'ALL',
    showModal: false,
    showModalCorte: false,
    invoice: initInvoice,
    serviceNumberIds: [],
    equipmentIds: defaultEquipmentsIds,
    serviceNumberEquipmentIds: [],
    formaPago: '',
    rfc: 'ALL',
    orderRFC: 'NONE',
    cutFolio: defaultCutFolio,
    cutFoliosToShow: undefined,
    IUS: '',
    idCutSelect: '',
    tabs: '1',
    buttonMarcarAInternas: false,
    downloadModal: false,
    pdf: true,
    excelModal: false,
    resendInvoiceModal: false,
    resendInvoiceId: undefined,
    resendInvoiceEmails: '',
    excelReportType: 'VENTAS',
    excelEmail: '',
    status: 'ALL',
    fiscalFolio: 'ALL',
    statusSat: 'ALL',
    cancelableSat: 'ALL',
    cancellationStatusSat: 'ALL',
    paymentWay: 'ALL',
    cancelationModalVisible: false,
    uuidSatToCancel: undefined,
    cancellationReason: undefined,
    fetching: false,
  };

  private getInitialTime = (): Moment => moment(this.props.initialDate);

  private getEndTime = (): Moment => moment(this.props.endedDate);

  /**
   * This function execute when the component is mounting and get the first page from
   * sales
   */
  public UNSAFE_componentWillMount(): void {
    this.props.setInitDate(
      moment().subtract(1, 'days').startOf('day').toDate(),
    );
    this.props.setEndDate(moment().endOf('day').toDate());
    if (!getDecodeToken().isClient) {
      this.chargeData();
    }
  }

  public componentWillUnmount(): void {
    this.props.cleanSales();
  }

  public async chargeData() {
    this.setState({ excelEmail: getDecodeToken().email });
    await this.props.getSystemConfigInvoice();
    await this.props.canRegisterUser();
    await this.props.getCompanySales();
    await this.props.getEquipmentsNumbers();
    await this.props.getFiscalPermission('');
    await this.props.getFormaPago();
    await this.props.getSystemConfig();
    const company =
      this.props.companySalesList && this.props.companySalesList[0];
    if (company !== undefined) {
      this.chargeInfoBilledAndCanceled(
        this.getInitialTime().toDate(),
        this.getEndTime().toDate(),
        company.distributionCenterId,
      );
      //this.chargeInfoBilledAndCanceled(this.getInitialTime().toDate(), this.getEndTime().toDate(), '00000000-0000-0000-0000-000000000000');
      await this.props.page({
        initDate: this.getInitialTime().toDate(),
        endDate: this.getEndTime().toDate(),
        serviceNumberIds: this.state.serviceNumberIds,
        equipmentIds: this.state.equipmentIds,
        type: this.state.type,
        status: this.state.status,
        paymentMethod: this.state.paymentWay,
        rfc: this.state.rfc,
        uuidSat: this.state.fiscalFolio,
        statusSat: this.state.statusSat,
        cancelableSat: this.state.cancelableSat,
        cancellationStatusSat: this.state.cancellationStatusSat,
        distCenterId: company.distributionCenterId,
        page: this.state.pagePosition,
      });
      //await this.props.getFiscalData("", true, this.state.dc.toString());
      //this.setState({ dc: '00000000-0000-0000-0000-000000000000' });
      // await this.props.getFiscalData("", true, company.distributionCenterId || '');
      this.setState({ dc: company.distributionCenterId || '' });
    }
    this.props.saleSelectedList.forEach((sale: SaleSelected) =>
      this.props.changeToBill(sale.id, false, sale.total, sale.totalVolume),
    );
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  public async chargeInfoBilledAndCanceled(
    init: Date,
    end: Date,
    DC: string | undefined,
  ) {
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /* await this.props.saleInfoBilled(init, end, DC || '');
    await this.props.saleInfoCanceled(init, end, DC || ''); */
  }

  /**
   * This function change page and replaces current position in the pagination
   */
  public handlePaginationChange = (currentPage: number): void => {
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: currentPage - 1,
    });
    this.setState({ valor: currentPage });
  };

  /**
   * This function called when a date picker (start or end) changes.
   */
  public onDatePickerCutChange = (
    startDateValue: Moment,
    endDateValue: Moment,
  ): void => {
    const start = moment(startDateValue);
    const end = moment(endDateValue);
    start.set({ hour: 0, minute: 0, seconds: 0 });
    end.set({ hour: 23, minute: 59, seconds: 59 });
    if (startDateValue) {
      this.onDatePickerChange(start, end);
    }
  };

  public onDatePickerChange = (
    startDateValue: Moment,
    endDateValue: Moment,
  ): void => {
    if (startDateValue && endDateValue) {
      this.onChangeTime(startDateValue, endDateValue);
    }
  };

  private async onChangeTime(startDateValue: Moment, endDateValue: Moment) {
    await this.props.setInitDate(startDateValue.toDate());
    await this.props.setEndDate(endDateValue.toDate());
    this.chargeInfoBilledAndCanceled(
      startDateValue.toDate(),
      endDateValue.toDate(),
      this.state.dc,
    );
    await this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    await this.setEquipmentIds(
      this.state.equipmentIds,
      startDateValue.toDate(),
      endDateValue.toDate(),
    );
    this.setState({ IUS: '' });
  }

  public onChangeEstatusSat = (value: SelectValue): void => {
    console.debug('Estatus SAT cambiado: ', value);
    this.setState({
      statusSat: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: value as string,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangeTypeCancelableSat = (value: SelectValue): void => {
    this.setState({
      cancelableSat: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: value as string,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangeCancellationStatusSat = (value: SelectValue): void => {
    this.setState({
      cancellationStatusSat: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: value as string,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangeRFC = (value: SelectValue): void => {
    console.debug('RFC cambiado: ', value);
    this.setState({
      rfc: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: value as string,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangeFiscalFolio = (value: SelectValue): void => {
    console.debug('Folio fiscal cambiado: ', value);
    this.setState({
      fiscalFolio: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: value as string,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  /**this function change radio element  and find status on the db from state element*/
  public onChangeType = (value: SelectValue): void => {
    this.setState({
      type: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: value as string,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangePaymentWay = (value: SelectValue): void => {
    this.setState({
      paymentWay: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: value as string,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    this.forceUpdate();
  };

  public onChangeOrderDate = (value: SelectValue): void => {
    this.setState({
      orderDate: value.toString(),
      orderRFC: 'NONE',
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public onChangeDistributionCenter = (value: string): void => {
    if (value === 'Todos') {
      this.onChangeDC('');
    } else this.onChangeDC(value);
  };

  public async onChangeDC(value: string) {
    this.setState({
      dc: value,
      equipmentIds: [],
      IUS: '',
    });
    this.chargeInfoBilledAndCanceled(
      this.getInitialTime().toDate(),
      this.getEndTime().toDate(),
      value,
    );
    await this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: value,
      page: this.state.pagePosition,
    });
    if (value == '') {
      value = '00000000-0000-0000-0000-000000000000';
    }
    await this.props.getFiscalData('', true, value);
  }

  getEquipmentsIdsFromServiceNumber = (serviceNumberId: string) => {
    const { fiscalPermissions } = this.props;
    const serviceNumber = fiscalPermissions.find(
      (fp) => fp.id === serviceNumberId,
    );
    if (serviceNumber) {
      return serviceNumber.equipments.map((e) => e.id);
    } else {
      return [];
    }
  };

  onSelectCutNumber = (value: string): void => {
    this.setState({ idCutSelect: value });
  };

  convertToInternal = async () => {
    if (!isEmpty(this.state.idCutSelect)) {
      try {
        this.setState({ buttonMarcarAInternas: false });
        await this.props.changeToInternal(this.state.idCutSelect);
      } catch (err) {
        this.setState({ buttonMarcarAInternas: false, idCutSelect: '' });
        console.log(err);
      }
      this.setState({
        showModalCorte: !this.state.showModalCorte,
        idCutSelect: '',
      });
      this.onChangeEquipment('', false);
    }
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    return 0;
  };
  convertToSales = async () => {
    if (!isEmpty(this.state.idCutSelect)) {
      try {
        this.setState({ buttonMarcarAInternas: false });
        await this.props.changeToSale(this.state.idCutSelect);
      } catch (err) {
        this.setState({ buttonMarcarAInternas: false, idCutSelect: '' });
        console.log(err);
      }
      this.setState({
        showModalCorte: !this.state.showModalCorte,
        idCutSelect: '',
      });
      this.onChangeEquipment('', false);
    }
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
    return 0;
  };

  public onChangeServiceNumber = (value: string, add: boolean): void => {
    const updated = add
      ? [...this.state.serviceNumberIds, value]
      : this.state.serviceNumberIds.filter((i) => i !== value);
    this.setState({
      serviceNumberIds: updated,
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: updated,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  setEquipmentIds = async (
    equipmentIds: Array<string>,
    initDate: Date | null = null,
    endDate: Date | null = null,
  ) => {
    if (equipmentIds.length > 0) {
      await this.props.setCortes(
        equipmentIds,
        initDate || this.getInitialTime().toDate(),
        endDate || this.getEndTime().toDate(),
      );
    } else {
      await this.props.clearCortes();
    }
    this.setCutFoliosToShow();
    this.setState({
      equipmentIds,
      cutFolio: defaultCutFolio,
      IUS: '',
    });
  };

  public onChangeEquipment = (value: string, add = true) => {
    let { equipmentIds } = this.state;
    if (add) {
      if (value === 'Todos') {
        equipmentIds = [];
        const equipmentsIdList = this.returnEquipmentsNumber();
        equipmentsIdList.forEach((eq) => {
          equipmentIds.push(eq);
        });
        this.setEquipmentIds(equipmentIds);
      } else {
        equipmentIds.push(value);
        this.setEquipmentIds(equipmentIds);
      }
    } else if (value === '') {
      equipmentIds = [];
      this.setEquipmentIds(equipmentIds);
    } else {
      equipmentIds = equipmentIds.filter((eid: string) => eid !== value);
      this.setEquipmentIds(equipmentIds);
    }
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public returnEquipmentsNumber = (): Array<string> => {
    const listaEquipments: Array<string> = this.props.equipmentNumbers
      .filter((en) => {
        if (this.state.dc === '00000000-0000-0000-0000-000000000000') {
          return true;
        } else if (this.state.serviceNumberEquipmentIds.length > 0) {
          if (
            this.state.serviceNumberEquipmentIds.some((eId) => eId === en.id)
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.state.dc) {
          if (this.state.dc === en.distributionCenterId) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .map((en: Equipment) => {
        return en.id;
      });
    return listaEquipments;
  };

  public onChangeFormaPago = (value: string): void => {
    this.setState({
      formaPago: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public onChangeRequiredInvoice = (value: SelectValue): void => {
    this.setState({
      invoiceRequired: value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public onChangeCutFolio = (value: Array<string>): void => {
    this.setState({
      cutFolio: value.includes('ALL')
        ? this.props.cortes.map((cF) => {
            return cF.cutid;
          })
        : value,
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public onChangeRfc = (value: SelectValue): void => {
    this.setState({
      rfc: value.toString(),
      IUS: '',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: value as string,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  public onChangeOrderRfc = (value: SelectValue): void => {
    this.setState({
      orderRFC: value,
      orderDate: 'NONE',
    });
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  setAlreadyInvoice = (saleId: string) => {
    this.props.alreadyInvoice(saleId, () => {
      this.props.page({
        initDate: this.getInitialTime().toDate(),
        endDate: this.getEndTime().toDate(),
        serviceNumberIds: this.state.serviceNumberIds,
        equipmentIds: this.state.equipmentIds,
        type: this.state.type,
        status: this.state.status,
        paymentMethod: this.state.paymentWay,
        rfc: this.state.rfc,
        uuidSat: this.state.fiscalFolio,
        statusSat: this.state.statusSat,
        cancelableSat: this.state.cancelableSat,
        cancellationStatusSat: this.state.cancellationStatusSat,
        distCenterId: this.state.dc,
        page: this.state.pagePosition,
      });
    });
  };

  onSelectPaymentType = async (row: Sale, value: string) => {
    await this.props.changePaymentType(row.id, value, this.state.dc);
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  onSelectFormaPago = async (row: Sale, value: string) => {
    await this.props.changeformaPago(row.id, value);
    this.props.page({
      initDate: this.getInitialTime().toDate(),
      endDate: this.getEndTime().toDate(),
      serviceNumberIds: this.state.serviceNumberIds,
      equipmentIds: this.state.equipmentIds,
      type: this.state.type,
      status: this.state.status,
      paymentMethod: this.state.paymentWay,
      rfc: this.state.rfc,
      uuidSat: this.state.fiscalFolio,
      statusSat: this.state.statusSat,
      cancelableSat: this.state.cancelableSat,
      cancellationStatusSat: this.state.cancellationStatusSat,
      distCenterId: this.state.dc,
      page: this.state.pagePosition,
    });
  };

  renderCutNumbers = () => {
    if (this.props.cortes.length > 0) {
      return this.props.cortes.map(
        (corte: Corte): JSX.Element => (
          <Select.Option
            key={corte.cutid}
            value={corte.cutid}
          >{`# ${corte.equipmentcutfolio.toString()} - Equipo: ${
            corte.equipmentnumber
          } ${subStringWithEllipsis(corte.equipmenttag, 14)}`}</Select.Option>
        ),
      );
    }
  };

  renderPermissionNumbers = () => {
    const { fiscalPermissions } = this.props;
    return fiscalPermissions.map(
      (np: FiscalPermission): JSX.Element => (
        <Select.Option key={np.id} value={np.id}>
          {np.numberPermission}
        </Select.Option>
      ),
    );
  };

  private renderDistributionCenterSelect = (): JSX.Element => {
    const { companySalesList } = this.props;
    return (
      <div>
        {!isEmpty(companySalesList) && (
          <Select
            size="small"
            style={{ width: '100%' }}
            value={this.state.dc}
            defaultValue="Todos"
            onChange={(value: string): void => {
              this.onChangeDistributionCenter(value);
            }}
          >
            <Select.Option style={{ fontSizeAdjust: 'initial' }} value="">
              Todos
            </Select.Option>
            {companySalesList.map(
              (dc: CompanySales): JSX.Element => (
                <Select.Option
                  key={dc.distributionCenterId}
                  style={{ fontSizeAdjust: 'initial' }}
                  value={dc.distributionCenterId}
                >
                  {dc.distributionCenterName}
                </Select.Option>
              ),
            )}
          </Select>
        )}
      </div>
    );
  };

  renderEquipmentNumbers = () =>
    this.props.equipmentNumbers
      .filter((en) => {
        if (this.state.dc === '00000000-0000-0000-0000-000000000000') {
          return true;
        } else if (this.state.serviceNumberEquipmentIds.length > 0) {
          if (
            this.state.serviceNumberEquipmentIds.some((eId) => eId === en.id)
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.state.dc) {
          if (this.state.dc === en.distributionCenterId) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .map(
        (en: Equipment): JSX.Element => (
          <Select.Option
            key={en.id}
            value={en.id}
          >{`${en.equipmentNumber} ${en.applicationType} ${en.tag}`}</Select.Option>
        ),
      );

  /**
   * This function render elements from the filters
   */
  private renderFilters = (): JSX.Element => {
    return (
      <Row
        style={{
          backgroundColor: '#F1F7FF',
          paddingLeft: 24,
          paddingRight: 24,
          paddingTop: 23,
          paddingBottom: 23,
        }}
      >
        {this.props?.permissionNumbersWithoutFolioSerie?.length > 0 &&
          isAllowed([P.CAN_VIEW_COMPANIES]) && (
            <Alert
              message={
                'Los siguientes números de permiso no tienen serie y folio asociados:'
              }
              description={
                <Typography.Paragraph
                  ellipsis={{
                    rows: 1,
                    expandable: true,
                    onExpand: () => {
                      // no-op
                    },
                  }}
                >
                  {this.props?.permissionNumbersWithoutFolioSerie?.join(', ')}
                </Typography.Paragraph>
              }
              type="error"
              closable
              // onClose={onClose}
            />
          )}
        <Row gutter={8}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={11}
            xl={8}
            xxl={6}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Consultar período de venta'}</label>
            <br />
            <DatePicker.RangePicker
              value={[
                moment(this.props.initialDate),
                moment(this.props.endedDate),
              ]}
              onChange={(dates: any) => {
                this.props.setInitDate(moment(dates[0]).toDate());
                this.props.setEndDate(moment(dates[1]).toDate());
              }}
              allowClear={false}
              style={{ width: '320px' }}
              showTime
              size="small"
              format={DATE_FORMAT}
              onOk={(dates: any): void => {
                this.onDatePickerChange(dates[0], dates[1]);
                this.props.saleSelectedList.forEach((sale: SaleSelected) =>
                  this.props.changeToBill(
                    sale.id,
                    false,
                    sale.total,
                    sale.totalVolume,
                  ),
                );
              }}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={9}
            xl={6}
            xxl={6}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">Centro de distribucion:</label>
            {this.renderDistributionCenterSelect()}
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Estatus SAT:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="ALL"
              value={this.state.statusSat}
              onChange={(value: SelectValue): void => {
                this.onChangeEstatusSat(value);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value={'ALL'}>Todos</Select.Option>
              <Select.Option value={'VIGENTE'}>Vigentes</Select.Option>
              <Select.Option value={'CANCELADO'}>Canceladas</Select.Option>
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Tipo de cancelación:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="ALL"
              value={this.state.cancelableSat}
              onChange={(value: SelectValue): void => {
                this.onChangeTypeCancelableSat(value);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value={'ALL'}>Todos</Select.Option>
              <Select.Option value={'CANCELABLE_CON_ACEPTACION'}>
                Cancelable con aceptación
              </Select.Option>
              <Select.Option value={'NO_CANCELABLE'}>
                No cancelable
              </Select.Option>
              <Select.Option value={'CANCELABLE_SIN_ACEPTACION'}>
                Cancelable sin aceptación
              </Select.Option>
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Estatus de cancelación:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="ALL"
              value={this.state.cancellationStatusSat}
              onChange={(value: SelectValue): void => {
                this.onChangeCancellationStatusSat(value);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value={'ALL'}>Todos</Select.Option>
              <Select.Option value={'EN_PROCESO'}>En proceso</Select.Option>
              <Select.Option value={'PLAZO_VENCIDO'}>
                Plazo vencido
              </Select.Option>
              <Select.Option value={'SOLICITUD_RECHAZADA'}>
                Solicitud rechazada
              </Select.Option>
              <Select.Option value={'CANCELADO_SIN_ACEPTACION'}>
                Cancelado sin aceptación
              </Select.Option>
              <Select.Option value={'CANCELADO_CON_ACEPTACION'}>
                Cancelado con aceptación
              </Select.Option>
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Tipo:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="ALL"
              value={this.state.type}
              onChange={(value: SelectValue): void => {
                this.onChangeType(value);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value={'ALL'}>Todos</Select.Option>
              <Select.Option value={'SIMPLE'}>Simple</Select.Option>
              <Select.Option value={'GROUPED'}>Agrupada</Select.Option>
              <Select.Option value={'GLOBAL'}>Global</Select.Option>
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Método de pago:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="ALL"
              value={this.state.paymentWay}
              onChange={(value: SelectValue): void => {
                this.onChangePaymentWay(value);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value={'ALL'}>Todos</Select.Option>
              <Select.Option value={'PUE'}>PUE</Select.Option>
              <Select.Option value={'PPD'}>PPD</Select.Option>
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            style={{ paddingLeft: 24, paddingRight: 24 }}
            hidden={this.props.systemConfig.isPermissionCreFromSale}
          >
            <label className="label">{'Número de equipo:'}</label>
            <Select
              mode="multiple"
              showSearch
              filterOption={(input, { props: { children } }) => {
                if (children !== undefined && children !== null) {
                  return (
                    children
                      .toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
                return false;
              }}
              defaultActiveFirstOption
              defaultValue={this.state.equipmentIds}
              value={this.state.equipmentIds}
              onSelect={(value: string) => this.onChangeEquipment(value)}
              onDeselect={(value: string) =>
                this.onChangeEquipment(value, false)
              }
              style={{ width: '100%', minWidth: 200 }}
            >
              <Select.Option value={'ALL'}>{'Todos'}</Select.Option>
              {this.renderEquipmentNumbers()}
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'RFC:'}</label>
            <PaginatedSelect
              url={'v1/invoices/rfcs/paginated'}
              size={6}
              onChange={this.onChangeRFC}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Folio fiscal:'}</label>
            <PaginatedSelect
              url={'v1/invoices/fiscalFolios/paginated'}
              size={6}
              onChange={this.onChangeFiscalFolio}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            style={{ paddingLeft: 24, paddingRight: 24 }}
            hidden={!this.props.systemConfig.isPermissionCreFromSale}
          >
            <label className="label">{'Número de permiso:'}</label>
            <Select
              optionFilterProp={'children'}
              mode="multiple"
              defaultActiveFirstOption
              // defaultValue=""
              onSelect={(value: string): void => {
                this.onChangeServiceNumber(value, true);
              }}
              onDeselect={(value: string): void => {
                this.onChangeServiceNumber(value, false);
              }}
              style={{ width: '100%' }}
            >
              <Select.Option value="ALL">Todos</Select.Option>
              {this.renderPermissionNumbers()}
            </Select>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={5}
            xxl={5}
            style={{ paddingLeft: 24, paddingRight: 24 }}
          >
            <label className="label">{'Mostrar cantidad como:'}</label>
            <Select
              defaultActiveFirstOption
              defaultValue="L"
              onChange={(value: SelectValue): void =>
                this.setState({ unitType: value.toString() })
              }
              style={{ width: '100%' }}
            >
              <Select.Option value={'L'}>Litros</Select.Option>
              <Select.Option value={'K'}>Kilos</Select.Option>
            </Select>
          </Col>
        </Row>
        <Row></Row>
      </Row>
    );
  };

  /**
   * Third step of the component wizard. Request email and create the
   * invoice.
   */
  private renderEmailForm = (): JSX.Element => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form>
        <Col span={24}>
          <p style={{ marginTop: 20, marginBottom: 20 }}>
            Ingresa el correo electronico donde quieres que te enviemos la
            factura
          </p>
          <Card
            className={'card-invoice-content'}
            style={{
              backgroundColor: '#f1f7ff',
              margin: '0 auto',
              maxWidth: '30rem',
            }}
          >
            <Form.Item hasFeedback label="Correo Electrónico">
              {getFieldDecorator('email', {
                rules: r.emailRule,
              })(<Input size="large" placeholder="Correo electrónico" />)}
            </Form.Item>
          </Card>
        </Col>
      </Form>
    );
  };

  renderCustomButton = (form: WrappedFormUtils<Invoice>): JSX.Element => (
    <Button
      size="large"
      type="primary"
      disabled={this.props.isFetching}
      onClick={() => this.onRequestInvoice(form)}
    >
      {this.props.isFetching ? 'Loading...' : 'Facturar'}
    </Button>
  );

  /**
   * This function is called when the button invoicing is
   * called. Is the final step.
   */
  private onRequestInvoice = (form: WrappedFormUtils<Invoice>): void => {
    form.validateFields(async (err, values: Invoice): Promise<void> => {
      if (err) {
        Promise.resolve();
      } else {
        this.setState({ invoice: { ...values } });
        const invoice = { ...values };
        this.props.form.validateFields(
          async (err, fields: Email): Promise<void> => {
            !Boolean((err || {}).email) &&
              Popups.executeOrNotifyError((): Promise<void> => {
                this.createInvoice(
                  this.props.salesStagingArea,
                  fields,
                  invoice,
                );
                form.resetFields();
                this.setState({ invoice: initInvoice });
                return Promise.resolve();
              });
          },
        );
      }
    });
  };

  private createInvoice = async (
    salesStagingArea: Sale[],
    fields: Email,
    invoice: Invoice,
  ): Promise<void> => {
    const Invoice = {
      ...invoice,
      email: fields.email,
      sales: salesStagingArea,
      fiscalRegime: invoice.fiscalRegime,
    };
    await this.props.saveInvoce(Invoice);
    this.props.addSaleToStagingArea('0', 0, true);
    Popups.notifySuccess(i8n.INVOICE_CREATED);
    this.setState({ showModal: !this.state.showModal });
    this.chargeData();
  };

  public renderCancelButton = (): JSX.Element => (
    <Button
      type="ghost"
      onClick={() => {
        this.setState({ showModal: !this.state.showModal });
        this.props.removeSaleToStagingArea(this.props.salesStagingArea[0]);
      }}
    >
      Cancelar <CloseCircleOutlined />
    </Button>
  );

  public getPaymentConditionType = (paymentCondition: string): string => {
    switch (paymentCondition) {
      case 'CASH':
        return 'Contado';
      case 'CREDIT':
        return 'Crédito';
      default:
        return 'vales';
    }
  };

  public getFormaPagoDescription = (formaPagoCodigoSat: string): string => {
    const { formaPago } = this.props;
    const fp = formaPago.find((fp) => fp.codigoSat === formaPagoCodigoSat);
    return fp ? fp.descripcion : '';
  };

  public sumaSelectSales = (sumaSelectSales: SaleSelected[]): number => {
    let sum = 0;
    sumaSelectSales.forEach((s) => (sum = sum + s.total));
    sum = this.props.sumTotalMBillable - sum;
    return sum;
  };

  public sumaSelectSalesLK = (sumaSelectSales: SaleSelected[]): number => {
    let sum = 0;
    sumaSelectSales.forEach((s) => (sum = sum + s.totalVolume));
    sum = this.props.sumTotalLKBillable - sum;
    return sum;
  };

  public formatNumber = (number: number): string =>
    Number(number.toFixed(2)).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });

  validateRenderSearchByIUS = (content: Sale[] | undefined): boolean =>
    this.state.type !== 'ERROR' &&
    !(
      !isEmpty(this.state.IUS) &&
      content !== undefined &&
      content.length === 1
    );

  validateRenderCollums = (): boolean => {
    if (this.state.type === 'INVOICE') return false;
    if (this.state.type === 'IN_PROGRESS') return false;
    return true;
  };

  cutFolioEqualsToState(cutFolio = []) {
    const cutFolioState: Array<string> = this.state.cutFolio;
    if (cutFolioState === cutFolio) return true;
    if (cutFolioState === null || cutFolio === null) return false;
    if (cutFolioState.length !== cutFolio.length) return false;
    for (let i = 0; i < cutFolioState.length; ++i) {
      if (cutFolioState[i] !== cutFolio[i]) return false;
    }
    return true;
  }

  public handleTableChange = (pagination: any, filters: any): void => {
    if (filters.endDate) {
      if (
        filters.endDate.length > 0 &&
        filters.endDate[0] !== this.state.orderDate
      ) {
        this.onChangeOrderDate(filters.endDate[0]);
      } else if (filters.endDate.length < 1) {
        this.onChangeOrderDate(this.state.orderDate);
      }
    }

    if (!this.cutFolioEqualsToState(filters.cutFolio)) {
      this.onChangeCutFolio(filters.cutFolio);
    }

    if (filters.invoiceRequired) {
      if (
        filters.invoiceRequired.length > 0 &&
        filters.invoiceRequired[0] !== this.state.invoiceRequired
      ) {
        this.onChangeRequiredInvoice(filters.invoiceRequired[0]);
      } else if (filters.invoiceRequired < 1) {
        this.onChangeRequiredInvoice(this.state.invoiceRequired);
      }
    }
    if (filters.invoiceRfc) {
      if (
        filters.invoiceRfc.length > 0 &&
        filters.invoiceRfc[0] !== this.state.orderRFC
      ) {
        this.onChangeOrderRfc(filters.invoiceRfc[0]);
      } else if (filters.invoiceRfc < 1) {
        this.onChangeOrderRfc(this.state.orderRFC);
      }
    }
  };

  setCutFoliosToShow = () => {
    let cutFoliosToShow = undefined;
    if (this.props.cortes.length > 0) {
      cutFoliosToShow = this.props.cortes
        .sort((a, b): number => {
          return a.equipmentcutfolio > b.equipmentcutfolio ? 1 : -1;
        })
        .sort((a, b): number => {
          return a.equipmentnumber < b.equipmentnumber ? 1 : -1;
        })
        .map((corte) => ({
          value: corte.cutid,
          text: `Equipo: ${
            corte.equipmentnumber
          } - # ${corte.equipmentcutfolio.toString()} ${subStringWithEllipsis(
            corte.equipmenttag,
            30,
          )}`,
        }));
      cutFoliosToShow.unshift({ value: 'NULL', text: 'Sin corte' });
      cutFoliosToShow.unshift({ value: 'ALL', text: 'Todos' });
    }
    this.setState({ cutFoliosToShow });
  };

  renderDescription = (name: string, value: string): JSX.Element => (
    <Descriptions bordered size="small" style={{ background: 'white' }}>
      <Descriptions.Item label={name}>{value}</Descriptions.Item>
    </Descriptions>
  );

  public renderSelectCenter = (): JSX.Element => (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={12}
      xl={12}
      xxl={12}
      style={{ paddingLeft: 24, paddingRight: 24 }}
    >
      <label className="label">Centro de distribucion:</label>
      {this.renderDistributionCenterSelect()}
    </Col>
  );

  public renderExtraTextOnSendAllSales = (quantity: number): string => {
    let text = '';
    if (quantity > 1000) {
      text =
        '\nLa cantidad de ventas que está por solicitar facturar puede hacer que el proceso de facturación tarde más de lo habitual.'
          .concat('\n¿Está seguro de continuar?')
          .concat('\n');
    }
    return text;
  };

  public renderSelectEquipment = (): JSX.Element => (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={12}
      xl={12}
      xxl={12}
      style={{ paddingLeft: 24, paddingRight: 24 }}
    >
      <label className="label">{'Número de equipo:'}</label>
      <Select
        mode="multiple"
        showSearch
        filterOption={(input, { props: { children } }) => {
          if (children !== undefined && children !== null) {
            return (
              children.toString().toLowerCase().indexOf(input.toLowerCase()) >=
              0
            );
          }
          return false;
        }}
        defaultActiveFirstOption
        defaultValue={this.state.equipmentIds}
        value={this.state.equipmentIds}
        onSelect={(value: string) => this.onChangeEquipment(value)}
        onDeselect={(value: string) => this.onChangeEquipment(value, false)}
        style={{ width: '100%', minWidth: 200 }}
      >
        <Select.Option value={'Todos'}>{'Todos'}</Select.Option>
        {this.renderEquipmentNumbers()}
      </Select>
    </Col>
  );

  public renderInformationTables = (): JSX.Element => (
    <div>
      <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={6}>
        <Text>Ventas</Text>
        {this.renderDescription(
          'Cantidad',
          this.formatNumber(this.props.multipleInvoicePage.totalElements || 0),
        )}
        {this.renderDescription(
          '$' + this.formatNumber(this.props.sumTotalM || 0),
          this.state.unitType === 'L'
            ? `${this.formatNumber(this.props.sumTotalLK || 0)} L`
            : `${this.formatNumber(this.props.sumTotalLK * 2 || 0)} K`,
        )}
      </Col>
      {this.state.type !== 'ERROR' &&
        this.state.type !== 'IN_PROGRESS' &&
        this.state.tabs !== '2' && (
          <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={6}>
            <Text>Ventas Facturables</Text>
            {this.renderDescription(
              'Cantidad',
              '' + this.formatNumber(this.props.totalElementsBillable || 0),
            )}
            {this.renderDescription(
              '$' + this.formatNumber(this.props.sumTotalMBillable || 0),
              this.state.unitType === 'L'
                ? `${this.formatNumber(this.props.sumTotalLKBillable || 0)} L`
                : `${this.formatNumber(
                    this.props.sumTotalLKBillable * 2 || 0,
                  )} K`,
            )}
          </Col>
        )}
      {this.state.type !== 'ERROR' &&
        this.state.type !== 'IN_PROGRESS' &&
        this.state.tabs !== '2' && (
          <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={6}>
            <Text>Ventas Seleccionadas</Text>
            {this.renderDescription(
              'Cantidad',
              '' +
                (this.props.totalElementsSelected -
                  this.props.saleSelectedList.length),
            )}
            {this.renderDescription(
              '$' + this.formatNumber(this.props.sumTotalMSelected || 0),
              this.state.unitType === 'L'
                ? `${this.formatNumber(this.props.sumTotalLKSelected || 0)} L`
                : `${this.formatNumber(
                    this.props.sumTotalLKSelected * 2 || 0,
                  )} K`,
            )}
          </Col>
        )}
      {this.state.type !== 'ERROR' &&
        this.state.type !== 'IN_PROGRESS' &&
        this.state.type !== 'NOT_INVOICE' && (
          <Col xs={24} sm={24} md={24} lg={12} xl={6} xxl={6}>
            <Spin tip="Cargando..." spinning={this.props.isFetchingBilled}>
              <Text>Facturas Realizadas</Text>
              {this.renderDescription(
                'cantidad',
                this.formatNumber(Number(this.props.totalSales) || 0),
              )}
              {this.renderDescription(
                '$' +
                  this.formatNumber(Number(this.props.billedSalestotal) || 0),
                this.state.unitType === 'L'
                  ? `${this.formatNumber(
                      Number(this.props.totalVolumeSalesTotal || 0),
                    )} L`
                  : `${this.formatNumber(
                      Number(this.props.totalVolumeSalesTotal || 0) * 2,
                    )} K`,
              )}
            </Spin>
          </Col>
        )}
    </div>
  );

  public renderTableData = (): JSX.Element => {
    const { multipleInvoicePage } = this.props;
    const content: InvoiceItem[] | undefined = multipleInvoicePage.content;
    return (
      <Table
        scroll={{ x: true }}
        rowKey={(record: InvoiceItem) => record.id}
        dataSource={content}
        pagination={false}
        onChange={this.handleTableChange}
        // rowClassName={(record) => !record.sale ? "sales_internal" : ""}
      >
        {/* <Table.Column title="Estatus factura" fixed='left' render={(text, row: Sale) => <Tag color={row.billed ? "green" : ""} >{row.billed ? "Facturada" : "Sin facturar"}</Tag>} />
      <Table.Column title="Estatus cancelación" dataIndex="status" fixed='left' render={(text) => <Text>{isEmpty(text) ? "Facturada" : text}</Text>} /> */}
        <Table.Column
          title="Tipo"
          dataIndex="type"
          key="type"
          render={(text) => (
            <>
              {text === 'SIMPLE' && <Tag>Simple</Tag>}
              {text === 'GROUPED' && <Tag>Agrupada</Tag>}
              {text === 'GLOBAL' && <Tag>Global</Tag>}
            </>
          )}
        />
        <Table.Column
          title="Estatus"
          key="status"
          render={(text, row: InvoiceItem) =>
            row.invoiceError != null ? (
              <Popover key={row.id} content={row.invoiceError}>
                <Tag
                  color={
                    row.status === 'Pendiente de envío'
                      ? '#E24C00'
                      : row.status === 'Facturada'
                      ? 'green'
                      : ''
                  }
                >
                  <ExclamationCircleOutlined
                    style={{ color: '#cd201f', marginRight: 5 }}
                  />
                  <>{row.status}</>
                </Tag>
              </Popover>
            ) : (
              <Tag
                color={
                  row.status === 'Pendiente de envío'
                    ? '#E24C00'
                    : row.status === 'Facturada'
                    ? 'green'
                    : ''
                }
              >
                {row.status}
              </Tag>
            )
          }
        />
        <Table.Column
          title="Tipo de cancelación"
          dataIndex="cancelableSat"
          key="cancelableSat"
          render={(text) => (
            <>
              {!text && <Text>N/A</Text>}
              {text === 'CANCELABLE_CON_ACEPTACION' && (
                <Text>Cancelable con aceptación</Text>
              )}
              {text === 'NO_CANCELABLE' && <Text>No cancelable</Text>}
              {text === 'CANCELABLE_SIN_ACEPTACION' && (
                <Text>Cancelable sin aceptación</Text>
              )}
            </>
          )}
        />
        <Table.Column
          title="Estatus de cancelación"
          dataIndex="cancellationStatusSat"
          key="cancellationStatusSat"
          render={(text) => (
            <>
              {!text && <Text>N/A</Text>}
              {text === 'EN_PROCESO' && <Text>En proceso</Text>}
              {text === 'PLAZO_VENCIDO' && <Text>Plazo vencido</Text>}
              {text === 'SOLICITUD_RECHAZADA' && (
                <Text>Solicitud rechazada</Text>
              )}
              {text === 'CANCELADO_SIN_ACEPTACION' && (
                <Text>Cancelado sin aceptación</Text>
              )}
              {text === 'CANCELADO_CON_ACEPTACION' && (
                <Text>Cancelado con aceptación</Text>
              )}
            </>
          )}
        />
        {!this.props.systemConfig.isPermissionCreFromSale && (
          <Table.Column
            title="Número de permiso"
            dataIndex="permissionNumber"
            key="permissionNumber"
          />
        )}
        {this.props.systemConfig.isPermissionCreFromSale ? (
          <Table.Column
            title="Número de permiso"
            dataIndex="grouper"
            key="groups"
          />
        ) : (
          <Table.Column
            title="Equipo"
            key="grouper"
            render={(text, row: InvoiceItem) => {
              const eq = this.props.equipmentNumbers.find(
                (e: Equipment) => e.id == row.grouper,
              );
              return eq
                ? `${eq.equipmentNumber} ${eq.applicationType} ${eq.tag}`
                : '';
            }}
          />
        )}
        <Table.Column
          title="Periodicidad"
          key="periodicity"
          render={(text, row: InvoiceItem) =>
            row.type == 'GLOBAL'
              ? `${toTitleCase(row.periodicity)} - ${toTitleCase(
                  row.periodicityMonth,
                )} - ${row.periodicityYear}`
              : 'No aplica'
          }
        />
        <Table.Column
          title="Fecha de solicitud"
          dataIndex="createdAt"
          key="createdAt"
          render={(text) => formatStringDateToDisplay(text)}
        />
        <Table.Column
          title="Fecha timbrado"
          dataIndex="stampedDate"
          key="stampedDate"
          render={(text) => formatStringDateToDisplay(text)}
        />
        <Table.Column
          title="RFC"
          dataIndex="rfc"
          key="rfc"
          render={(text) => <Typography.Text copyable>{text}</Typography.Text>}
        />
        <Table.Column
          title="Facturado por"
          dataIndex="billerName"
          key="billerName"
          render={(text) => <Typography.Text>{text || 'N/A'}</Typography.Text>}
        />
        <Table.Column
          title="Folio fiscal"
          key="ficalFolio"
          dataIndex="uuidSat"
          render={(text) =>
            text && <Typography.Text copyable>{text}</Typography.Text>
          }
        />
        <Table.Column
          title="Método de pago"
          key="paymentWay"
          dataIndex="formaPago"
          render={(text) => (text == '99' ? 'PPD' : 'PUE')}
        />
        <Table.Column
          title={'Cantidad(' + this.state.unitType + ')'}
          dataIndex="totalVolume"
          key="totalVolume"
          render={(text: string): React.ReactNode => {
            return this.state.unitType === 'L'
              ? this.formatNumber(Number(text))
              : this.formatNumber(Number(text) * 2);
          }}
        />
        <Table.Column
          title="Monto"
          dataIndex="total"
          key="total"
          render={(row: string) => (
            <Text>{'$' + this.formatNumber(Number(row))}</Text>
          )}
        />

        {/* <Table.Column title="Monto" dataIndex="total" key="total" render={(row: string) => <Text>{'$' + this.formatNumber(Number(row))}</Text>} /> */}

        {this.state.type !== 'IN_PROGRESS' && (
          <Table.Column
            title="Acciones"
            dataIndex="invoice"
            key="invoice"
            width={100}
            fixed="right"
            render={(text: string, record: InvoiceItem): React.ReactNode => {
              if (record.stampedDate && record.statusSat !== 'CANCELADO') {
                return (
                  <Row gutter={[4, 4]}>
                    <Col span={24} style={{ display: 'flex', gap: 2 }}>
                      <Popover content={'Reenviar factura'} trigger="hover">
                        <Button
                          onClickCapture={() => {
                            // this.props.resendInvoice(record.id, 'misael@ssf.mx,misajimenez.mx@gmail.com')
                            this.setState({
                              resendInvoiceModal: true,
                              resendInvoiceId: record.id,
                            });
                          }}
                          className="icon_button"
                          icon="mail"
                        />
                      </Popover>
                      <Popover content={'Cancelar factura'} trigger="hover">
                        <Button
                          className="icon_button"
                          icon="stop"
                          onClickCapture={() => {
                            this.setState({
                              cancelationModalVisible: true,
                              uuidSatToCancel: record.uuidSat,
                            });
                          }}
                        />
                      </Popover>
                    </Col>
                    <Col span={24} style={{ display: 'flex', gap: 2 }}>
                      <Popover
                        content={`Ver venta${
                          record.type !== 'SIMPLE' ? 's' : ''
                        }`}
                        trigger="hover"
                      >
                        <Button
                          href={`/sales?invoiceId=${record.id}`}
                          icon="eye"
                          className="icon_button"
                        />
                      </Popover>
                      <Popover content={'PDF'} trigger="hover">
                        <Button
                          style={{ color: '#AF0001' }}
                          onClickCapture={() =>
                            this.props.downloadFileByUuidSat(
                              record.uuidSat,
                              'file.pdf',
                            )
                          }
                          icon="file-pdf"
                          className="icon_button"
                        />
                      </Popover>
                      <Popover content={'XML'} trigger="hover">
                        <Button
                          style={{ color: '#F29C1F' }}
                          onClickCapture={() =>
                            this.props.downloadFileByUuidSat(
                              record.uuidSat,
                              'file.xml',
                            )
                          }
                          icon="file-text"
                          className="icon_button"
                        />
                      </Popover>
                      {record.type == 'GLOBAL' && (
                        <Popover
                          content={'Ver notas de crédito'}
                          trigger="hover"
                          placement="topRight"
                        >
                          <Button
                            // style={{color:'#AF0001'}}
                            href={`/credit-notes?loteId=${record.loteFactura.loteId}`}
                            icon="exception"
                            className="icon_button"
                          />
                        </Popover>
                      )}
                    </Col>
                  </Row>
                );
              } else if (record.statusSat === 'CANCELADO') {
                return (
                  <Row gutter={[4, 4]}>
                    <Col span={24} style={{ display: 'flex', gap: 2 }}>
                      <Popover content={'XML Cancelación'} trigger="hover">
                        <Button
                          style={{ color: '#F29C1F' }}
                          onClickCapture={() =>
                            this.props.downloadFileByUuidSat(
                              record.uuidSat,
                              'cancel.xml',
                            )
                          }
                          icon="file-text"
                          className="icon_button"
                        />
                      </Popover>
                    </Col>
                  </Row>
                );
              } else {
                return <></>;
              }
            }}
          />
        )}
      </Table>
    );
  };

  validateZip = (): boolean => {
    if (this.state.rfc === 'ALL') {
      Popups.notifyError('Selecciona un unico RFC');
      return false;
    }
    if (this.state.rfc !== 'XAXX010101000') {
      return this.validateNumberOfInvoice();
    } else {
      const validYear =
        this.getInitialTime().year() === this.getEndTime().year();
      const validMonth =
        this.getInitialTime().month() === this.getEndTime().month();
      const validDay = this.getInitialTime().day() === this.getEndTime().day();
      if (validYear && validMonth && validDay) {
        return this.validateNumberOfInvoice();
      } else {
        Popups.notifyError(
          'Solo es posible exportar facturas de 1 dia para este RFC',
        );
        return false;
      }
    }
  };

  validateNumberOfInvoice = (): boolean => {
    if (Number(this.props.billedSalestotal) || 0 > 1) {
      return true;
    } else {
      Popups.notifyError('No existen facturas a exportar');
      return false;
    }
  };

  handleCloseCancellationModal = () => {
    this.setState({ cancelationModalVisible: false });
  };

  public render = (): React.ReactNode => {
    const { isFetching, systemConfigInvoice } = this.props;
    const { maxZipTimeHours, maxZipTimeMinutes } = systemConfigInvoice;
    let zipModalText = '';
    if (maxZipTimeHours > 0) {
      if (maxZipTimeHours > 1) zipModalText = maxZipTimeHours + 'Horas';
      else zipModalText = maxZipTimeHours + ' Hora';
      if (maxZipTimeMinutes > 0)
        zipModalText = zipModalText + ' y ' + maxZipTimeMinutes + ' Minutos';
    } else {
      zipModalText = maxZipTimeMinutes + ' Minutos';
    }
    if (getDecodeToken().isClient) {
      return <Redirect to="/home" />;
    }
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Spin tip="Cargando..." spinning={isFetching}>
        <Modal
          title="Agregar datos fiscales"
          visible={this.state.showModal}
          width="100rem"
          centered
          destroyOnClose
          style={{ paddingTop: '0px' }}
          closable={false}
          cancelButtonProps={{ hidden: true }}
          okButtonProps={{ hidden: true }}
        >
          <FiscalDataForm
            showFiscalDataProvidedNext={false}
            showFiscalDataProvidedPrev={false}
            isFetching={isFetching}
            invoice={this.state.invoice}
            customChildren={this.renderEmailForm}
            customButton={this.renderCustomButton}
            renderCancelButton={this.renderCancelButton}
          />
        </Modal>
        <Modal
          title="Fecha de Corte"
          visible={this.state.showModalCorte}
          width={window.innerWidth < 768 ? '95%' : '60%'}
          style={{ paddingTop: '0px' }}
          closable={false}
          cancelButtonProps={{ hidden: true }}
          okButtonProps={{ hidden: true }}
        >
          <Row>
            {this.renderSelectCenter()}
            {this.renderSelectEquipment()}
          </Row>
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
              xxl={12}
              style={{ paddingLeft: 24, paddingRight: 24 }}
            >
              <label className="label">{'Consultar período'}</label>
              <br />
              <DatePicker.RangePicker
                style={{ width: '100%' }}
                value={[
                  moment(this.props.initialDate),
                  moment(this.props.endedDate),
                ]}
                onChange={(dates: any) => {
                  this.props.setInitDate(moment(dates[0]).toDate());
                  this.props.setEndDate(moment(dates[1]).toDate());
                }}
                showTime
                size="small"
                format={DATE_FORMAT}
                onOk={(dates: any): void => {
                  this.onDatePickerChange(dates[0], dates[1]);
                  this.props.saleSelectedList.forEach((sale: SaleSelected) =>
                    this.props.changeToBill(
                      sale.id,
                      false,
                      sale.total,
                      sale.totalVolume,
                    ),
                  );
                }}
              />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
              xxl={12}
              style={{ paddingLeft: 24, paddingRight: 24 }}
            >
              <label className="label">{'Número de corte:'}</label>
              <Select
                defaultActiveFirstOption
                showSearch
                value={this.state.idCutSelect}
                filterOption={(input, { props: { children } }) => {
                  if (children !== undefined && children !== null) {
                    return (
                      children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                  return false;
                }}
                onSelect={(value: string): void => {
                  this.onSelectCutNumber(value);
                  this.setState({ buttonMarcarAInternas: true });
                }}
                style={{ width: '100%' }}
              >
                {this.renderCutNumbers()}
              </Select>
            </Col>
          </Row>
          <Row style={{ paddingTop: '50px' }}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={9}
              xxl={9}
              style={{ paddingLeft: '24px', paddingRight: '24px' }}
            >
              <Popconfirm
                disabled={!this.state.buttonMarcarAInternas}
                title={`Esta seguro que desea convertr estas ventas a internas?`}
                okText="Si"
                cancelText="No"
                onConfirm={this.convertToInternal}
              >
                <Button disabled={!this.state.buttonMarcarAInternas}>
                  Convertir ventas a internas
                </Button>
              </Popconfirm>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={9}
              xxl={9}
              style={{ paddingLeft: '24px', paddingRight: '24px' }}
            >
              <Popconfirm
                disabled={!this.state.buttonMarcarAInternas}
                title={`Esta seguro que desea convertir estas pruebas internas a ventas?`}
                okText="Si"
                cancelText="No"
                onConfirm={this.convertToSales}
              >
                <Button disabled={!this.state.buttonMarcarAInternas}>
                  Convertir internas a ventas
                </Button>
              </Popconfirm>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={6}
              xxl={6}
              style={{ paddingLeft: '24px', paddingRight: '24px' }}
            >
              <Button
                onClick={() => {
                  this.setState({
                    showModalCorte: !this.state.showModalCorte,
                    idCutSelect: '',
                  });
                  this.onChangeEquipment('', false);
                }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={`Descarga xml y pdf de las facturas de ${this.state.rfc}`}
          visible={this.state.downloadModal}
          width={window.innerWidth < 768 ? '95%' : '60%'}
          style={{ paddingTop: '0px' }}
          closable={false}
          cancelButtonProps={{ hidden: true }}
          okButtonProps={{ hidden: true }}
        >
          <Row>
            <p>
              Se descargaran las facturas realizadas desde{' '}
              {moment(this.props.initialDate).format(DATE_FORMAT)} hasta{' '}
              {moment(this.props.endedDate).format(DATE_FORMAT)}
            </p>
            <p>
              Se enviara las instrucciones de descarga el archivo zip al correo:{' '}
              {getDecodeToken().email}
            </p>
            <p>
              El archivo estara disponible {zipModalText} apartir de la
              recepcion del correo
            </p>
          </Row>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={4}>
              <Button
                type="primary"
                onClick={() => {
                  this.props.getZipFile(
                    this.getInitialTime().toDate(),
                    this.getEndTime().toDate(),
                    this.state.dc,
                    getDecodeToken().email,
                    this.state.rfc,
                  );
                  this.setState({ downloadModal: !this.state.downloadModal });
                }}
              >
                Aceptar y Enviar
              </Button>
            </Col>
            <Col xs={24} sm={{ span: 4, offset: 16 }}>
              <Button
                type="danger"
                onClick={() => {
                  this.setState({ downloadModal: !this.state.downloadModal });
                }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Modal>
        <Form>
          <Modal
            title={`Generación de Reporte Excel`}
            visible={this.state.excelModal}
            width={window.innerWidth < 768 ? '95%' : '60%'}
            style={{ paddingTop: '0px' }}
            closable={false}
            cancelButtonProps={{ hidden: true }}
            okButtonProps={{ hidden: true }}
          >
            <Row>
              <p>
                El reporte incluirá facturas desde la fecha{' '}
                {moment(this.props.initialDate).format(DATE_FORMAT)} hasta{' '}
                {moment(this.props.endedDate).format(DATE_FORMAT)}
              </p>
              <p>
                Se enviara las instrucciones de descarga del documento Excel al
                correo: {this.state.excelEmail}
              </p>
              <p>
                Si lo desea, puede modificar la dirección de correo a la cual se
                enviará el reporte solicitado.
              </p>
            </Row>
            <Row>
              <Form.Item>
                {getFieldDecorator('email', {
                  initialValue: this.state.excelEmail,
                  rules: [
                    {
                      required: true,
                      type: 'email',
                      message: 'Ingresa un correo electrónico valido',
                    },
                  ],
                })(
                  <Input
                    placeholder="Correo electrónico"
                    onChange={(output) => {
                      this.setState({ excelEmail: output.target.value });
                    }}
                  />,
                )}
              </Form.Item>
            </Row>
            <br></br>
            <Row gutter={[10, 10]}>
              <Col xs={24} sm={4}>
                <Button
                  type="primary"
                  onClick={() => {
                    this.props.createExcelByFilters(
                      {
                        initDate: this.getInitialTime().toDate(),
                        endDate: this.getEndTime().toDate(),
                        serviceNumberIds: this.state.serviceNumberIds,
                        equipmentIds: this.state.equipmentIds,
                        type: this.state.type,
                        status: this.state.status,
                        paymentMethod: this.state.paymentWay,
                        rfc: this.state.rfc,
                        uuidSat: this.state.fiscalFolio,
                        statusSat: this.state.statusSat,
                        cancelableSat: this.state.cancelableSat,
                        cancellationStatusSat: this.state.cancellationStatusSat,
                        distCenterId: this.state.dc,
                        page: this.state.pagePosition,
                      },
                      this.state.excelEmail,
                    );
                    this.setState({ excelModal: !this.state.excelModal });
                  }}
                >
                  Generar Reporte Excel
                </Button>
              </Col>
              <Col xs={24} sm={{ span: 4, offset: 16 }}>
                <Button
                  type="danger"
                  onClick={() => {
                    this.setState({ excelModal: !this.state.excelModal });
                  }}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Modal>
        </Form>
        <Form>
          <Modal
            title={`Reenviar factura`}
            visible={this.state.resendInvoiceModal}
            width={window.innerWidth < 768 ? '95%' : '60%'}
            style={{ paddingTop: '0px' }}
            closable={false}
            cancelButtonProps={{ hidden: true }}
            okButtonProps={{ hidden: true }}
          >
            <Row>
              <p>
                Se enviara las instrucciones de descarga del documento al
                correo(s): {this.state.resendInvoiceEmails}
              </p>
              <p>
                Si lo desea, puede modificar la(s) dirección(es) de correo(s) a
                la cual se enviará la factura solicitada, defina correos
                electronicos separados por coma &quot;,&quot;.
              </p>
            </Row>
            <Row>
              <Form.Item>
                {getFieldDecorator('resendInvoiceEmails', {
                  initialValue: this.state.resendInvoiceEmails,
                  rules: [
                    {
                      required: true,
                      message: 'Ingresa almenos un correo electrónico valido',
                    },
                    {
                      validator: (_, value, callback) => {
                        const emails = value
                          .split(',')
                          .map((email: string) => email.trim());
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                        const invalidEmails = emails.filter(
                          (email: string) => !emailRegex.test(email),
                        );
                        if (invalidEmails.length > 0) {
                          callback(
                            `Correo(s) inválido(s): ${invalidEmails.join(
                              ', ',
                            )}`,
                          );
                        } else {
                          callback();
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    placeholder="Correo electrónico"
                    onChange={(output) => {
                      this.setState({
                        resendInvoiceEmails: output.target.value,
                      });
                    }}
                  />,
                )}
              </Form.Item>
            </Row>
            <br></br>
            <Row gutter={[10, 10]}>
              <Col xs={24} sm={4}>
                <Button
                  type="primary"
                  onClick={() => {
                    if (
                      this.state.resendInvoiceId &&
                      this.state.resendInvoiceEmails
                    ) {
                      this.props.resendInvoice(
                        this.state.resendInvoiceId,
                        this.state.resendInvoiceEmails,
                      );
                      this.setState({
                        resendInvoiceModal: !this.state.resendInvoiceModal,
                        resendInvoiceId: null,
                        resendInvoiceEmails: '',
                      });
                    }
                  }}
                >
                  Reenviar factura
                </Button>
              </Col>
              <Col xs={24} sm={{ span: 4, offset: 16 }}>
                <Button
                  type="danger"
                  onClick={() => {
                    this.setState({
                      resendInvoiceModal: !this.state.resendInvoiceModal,
                      resendInvoiceId: null,
                      resendInvoiceEmails: '',
                    });
                  }}
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </Modal>
        </Form>

        <Form>
          <Modal
            title={`Registro motivo de cancelación`}
            visible={this.state.cancelationModalVisible}
            closable={true}
            onCancel={this.handleCloseCancellationModal}
            cancelButtonProps={{ hidden: true }}
            okButtonProps={{ hidden: true }}
            footer={
              <Popconfirm
                title="¿Deseas proceder con la cancelación de la factura?"
                onConfirm={async () => {
                  if (!this.state?.cancellationReason) {
                    Popups.notifyError(
                      'Por favor, elija el motivo de cancelación',
                    );
                    return;
                  }
                  if (!this.state?.uuidSatToCancel) {
                    Popups.notifyError(
                      'Ocurrió un error al cargar el registro, sin folio fiscal',
                    );
                    return;
                  }
                  try {
                    this.setState({ fetching: true });
                    await this.props.cancelInvoiceByUuidSat(
                      this.state?.uuidSatToCancel,
                      this.state?.cancellationReason,
                    );
                    await sleep(1000);
                    await this.props.page({
                      initDate: this.getInitialTime().toDate(),
                      endDate: this.getEndTime().toDate(),
                      serviceNumberIds: this.state.serviceNumberIds,
                      equipmentIds: this.state.equipmentIds,
                      type: this.state.type,
                      status: this.state.status,
                      paymentMethod: this.state.paymentWay,
                      rfc: this.state.rfc,
                      uuidSat: this.state.fiscalFolio,
                      statusSat: this.state.statusSat,
                      cancelableSat: this.state.cancelableSat,
                      cancellationStatusSat: this.state.cancellationStatusSat,
                      distCenterId: this.state.dc,
                      page: this.state.pagePosition,
                    });
                  } catch (error) {
                    Popups.notifyError(error.message);
                  } finally {
                    this.setState({
                      cancellationReason: undefined,
                      fetching: false,
                    });
                    this.handleCloseCancellationModal();
                  }
                }}
                okText="Confirmar"
                cancelText="Cancelar"
              >
                <Button type="primary" loading={this.state.fetching}>
                  Cancelar factura
                </Button>
              </Popconfirm>
            }
          >
            <Row>
              <Typography.Paragraph>Folio fiscal:</Typography.Paragraph>
              <Typography.Paragraph strong>
                {this.state.uuidSatToCancel}
              </Typography.Paragraph>
              <Typography.Paragraph>
                Motivo de cancelación:
              </Typography.Paragraph>
              <Col>
                <Select
                  value={this.state.cancellationReason}
                  onChange={(e) => {
                    this.setState({ cancellationReason: e });
                  }}
                  style={{ width: '100%' }}
                  placeholder="Selecciona un motivo de cancelación"
                  disabled={this.state.fetching}
                >
                  <Select.Option value={'02'}>
                    02 Comprobantes emitidos con errores sin relación
                  </Select.Option>
                  <Select.Option value={'03'}>
                    03 No se llevó a cabo la operación
                  </Select.Option>
                </Select>
              </Col>
            </Row>
          </Modal>
        </Form>

        <div className={'content-backgroud'}>
          {this.renderFilters()}
          <Row style={{ marginLeft: 20, marginRight: 20 }}>
            <Row gutter={16} style={{ marginTop: 20 }}>
              <Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6}>
                <button
                  type="button"
                  className="link-button"
                  onClickCapture={() => {
                    this.setState({
                      excelModal: true,
                      excelReportType: 'Facturas Canceladas',
                    });
                  }}
                >
                  Generar Reporte Excel <FileExcelOutlined /> <ExportOutlined />
                </button>
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Col span={24} style={{ backgroundColor: 'white' }}>
                <Tabs activeKey={'facturas'}>
                  <Tabs.TabPane key="facturas" tab="Facturas">
                    {this.renderTableData()}
                  </Tabs.TabPane>
                </Tabs>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Pagination
                  style={{ flex: 1 }}
                  current={this.props.multipleInvoicePage.number + 1 || 0}
                  total={this.props.multipleInvoicePage.totalElements}
                  onChange={this.handlePaginationChange}
                  defaultPageSize={10}
                />
              </Col>
            </Row>
          </Row>
        </div>
      </Spin>
    );
  };

  isHiddenElement = (elementName: string, filterName: string): boolean => {
    /*
    posibles filterName

    "SALE_INVOICE"
    "NOT_INVOICE"
    "INVOICE"
    "IN_PROGRESS"
    "ERROR" */

    switch (elementName) {
      case 'Botones para facturar':
        if (filterName === 'IN_PROGRESS' || filterName === 'ERROR') {
          return true;
        }
        break;
      case 'All Results Excel':
        if (filterName !== 'SALE_INVOICE' && filterName !== 'ERROR')
          return true;
        break;
      default:
        break;
    }
    return false;
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    multipleInvoicePage: states.multipleInvoiceState.multipleInvoicePage,
    isFetching: states.saleState.isFetching,
    isFetchingBilled: states.saleState.isFetchingBilled,
    companySalesList: states.companyState.companySalesList,
    initialDate: states.saleState.initDate,
    endedDate: states.saleState.endDate,
    multicenter: states.companyState.multicenter,
    isEquimentNumber: states.companyState.isEquimentNumber,
    sumTotalLK: states.saleState.sumTotalLK,
    sumTotalM: states.saleState.sumTotalM,
    sumTotalLKBillable: states.saleState.sumTotalLKBillable,
    sumTotalMBillable: states.saleState.sumTotalMBillable,
    sumTotalLKSelected: states.saleState.sumTotalLKSelected,
    sumTotalMSelected: states.saleState.sumTotalMSelected,
    saleSelectedList: states.saleState.saleSelectedList,
    salesStagingArea: states.invoiceState.salesStagingArea,
    paymentChange: states.saleState.paymentChange,
    totalElementsBillable: states.saleState.totalElementsBillable,
    totalElementsSelected: states.saleState.totalElementsSelected,
    fiscalPermissions: states.companyState.fiscalPermissions,
    equipmentNumbers: states.companyState.equipments,
    formaPago: states.saleState.formaPago,
    fiscalDataList: states.invoiceUserState.fiscalDataList,
    canRegistred: states.loginState.canRegistred,
    cortes: states.saleState.cortes,
    totalSales: states.saleState.totalSales,
    billedSalestotal: states.saleState.billedSalestotal,
    totalVolumeSalesTotal: states.saleState.totalVolumeSalesTotal,
    totalSalesSize: states.saleState.totalSalesSize,
    totalCancel: states.saleState.totalCancelSales,
    systemConfigInvoice: states.configurationState.systemConfigInvoice,
    counterOnlySales: states.saleState.counterOnlySales,
    systemConfig: states.configurationState.systemConfig,
    permissionNumbersWithoutFolioSerie:
      states.saleState.permissionNumbersWithoutFolioSerie,
  };
};

const mapDispatchToProps = {
  page,
  downloadFileByUuidSat,
  invoicingSale,
  sendAllSalesToInvoice,
  changeBillable,
  changePaymentType,
  changeformaPago,
  changeToBill,
  resendInvoce,
  resendInvoice,
  getCompanySales,
  setInitDate,
  setEndDate,
  alreadyInvoice,
  cancelInvoiceByUuidSat,
  invoiceAll,
  addSaleToStagingArea,
  removeSaleToStagingArea,
  saveInvoce,
  getFiscalPermission,
  getEquipmentsNumbers,
  cleanSales,
  getFormaPago,
  getFiscalData,
  canRegisterUser,
  setCortes,
  clearCortes,
  getSaleByIus,
  changeCustomer,
  changeToInternal,
  changeToSale,
  getZipFile,
  getSystemConfigInvoice,
  createExcelByFilters,
  getSystemConfig,
};

export default connect<
  StateProps,
  DispatchProps,
  Record<string, unknown>,
  RootState
>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(MultipleInvoicesListComponent));
